import { Grid } from "@mui/material";
import WelcomeStepFour from "./welcomeStepFour";
import WelcomeStepOne from "./welcomeStepOne";
import WelcomeStepThree from "./welcomeStepThree";
import WelcomeStepTwo from "./welcomeStepTwo";

const WelcomeSteps = (): React.JSX.Element => (
  <Grid
    container
    spacing={4}
    sx={{ mb: 4, textAlign: "center" }}
    rowSpacing={6}
  >
    <Grid item xs={12} sm={6} lg={3}>
      <WelcomeStepOne />
    </Grid>

    <Grid item xs={12} sm={6} lg={3}>
      <WelcomeStepTwo />
    </Grid>

    <Grid item xs={12} sm={6} lg={3}>
      <WelcomeStepThree />
    </Grid>

    <Grid item xs={12} sm={6} lg={3}>
      <WelcomeStepFour />
    </Grid>
  </Grid>
);

export default WelcomeSteps;
